/**
 * @generated SignedSource<<c5561699a860ff47cd424fab774653a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllocationAssistanceModal_project$data = {
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PredictedEndDateModalStatsSection_project">;
  readonly " $fragmentType": "AllocationAssistanceModal_project";
};
export type AllocationAssistanceModal_project$key = {
  readonly " $data"?: AllocationAssistanceModal_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"AllocationAssistanceModal_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AllocationAssistanceModal_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PredictedEndDateModalStatsSection_project"
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "ccd989af222d51ebce06206eb2d684a1";

export default node;
